import { t } from 'i18next';
import { useGetGrantsModules } from 'queries';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import EditGrantsModuleForm from './EditGrantsModuleForm';
import useColumnDefinitions from './hooks/useColumnDefinitions';
import { isSDBAccount } from 'utils/misc';

const GrantsModules = () => {
  const { data: rows, isFetching } = useGetGrantsModules();
  const columnDefinitions = useColumnDefinitions();

  return (
    <TableCRUDLayout
      FormComponent={EditGrantsModuleForm}
      loading={isFetching}
      columns={columnDefinitions}
      rows={rows}
      getRowId={(row) => row.grantCatalogId}
      confirmationTitle={t('deleteDialog.title')}
      confirmationBody={t('deleteDialog.body')}
      hideCreateAction={true}
      editable={isSDBAccount()}
      disableActions={!isSDBAccount()}
    />
  );
};

export default GrantsModules;
